import React, { useEffect, useState, useRef, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { CheckSession, FormatCurrency, GetCoockie, GetShoppingCart } from "../../GlobalScript";
import Cookies from 'js-cookie';
import ReactPaginate from 'react-paginate';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InputGroup from 'react-bootstrap/InputGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import HistoryDetail from '../HistoryDetail';
import FooterDealer from '../../FooterDealer.js';
import { ShoppingCartContext } from '../ShoppingCartContext';
export default function OrderHistory() {

    const navigate = useNavigate();
    const itemsPerPage = 10;
    const [orderItems, setOrderItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [activeRow, setActiveRow] = useState(null);
    const dropdownRef = useRef(null);
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    /*const currentItems = orderItems.slice(itemOffset, endOffset);*/
    const pageCount = Math.ceil(orderItems.length / itemsPerPage);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const currentItems = orderItems.slice(itemOffset, endOffset);
    const historyType = 'order';
    const location = useLocation();
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [OrderStatusList, setOrderStatusList] = useState(false);
    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext);

    const handleDetailsModalShow = async (order) => {
        await GetOrderDetail(order);
        setShowDetailsModal(true);
    }
    const handleDetailsModalClose = () => {
        setShowDetailsModal(false);
        setSelectedOrder(null);
        if (location.state) {
            window.history.replaceState({}, '')
        }
    }
    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            setKeyword(location.state.id);
        }
    }, [location])
    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '') {
            LoadOrders('', false);
        }
    }, [keyword])
    useEffect(() => {
        if (location.state && location.state.id && location.state.id !== '' && orderItems && orderItems.length > 0) {
            handleDetailsModalShow(orderItems[0])
        }
    }, [orderItems])
    const GetOrderDetail = async (order) => {
        const response = await fetch("kdealer/GetOrderDetail/" + order.refID);
        if (response.status !== 200) {
            return;
        }
        const items = await response.json();
        const orderToShow = {
            order: order,
            orderDetail: items
        }
        setSelectedOrder(orderToShow);
    }
    useEffect(() => {
        if (loading === true) {    
            LoadOrders('', false);
            setLoading(false);
        }
    }, [loading]);
    useEffect(() => {
        if (!OrderStatusList) {
            LoadOrderStatusList();
        }
    }, [OrderStatusList]);
    const ResetSearch = async () => {
        setKeyword('');
        setStatus('');
        setDateFrom('');
        setDateTo('');
        setLoading(true);
    }
    const LoadOrderStatusList = async () => {
        try {
            CheckSession();
            const response = await fetch("kdealer/GetOrderStatusList");
            if (response.status !== 200) {
                return;
            }
            const lst = await response.json();
            setOrderStatusList(lst);
        }
        catch (e) {
            console.log(e);
            return;
        }
    }
    const LoadOrders = async (orderby, inc) => {
        try {
            CheckSession();
            const user = GetCoockie();
            const data = {
                keyword: keyword,
                status: status,
                dateFrom: dateFrom,
                dateTo: dateTo,
                orderBy: orderby,
                inc: inc,
                dealerId: user.dealerID
            }
            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(data)
            };
            const response = await fetch("kdealer/GetOrders", requestOptions);
            if (response.status !== 200) {
                return;
            }
            const orders = await response.json();
            setOrderItems(orders);
            console.log(orders)
        }
        catch (e) {
            console.log(e);
            return;
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        if (name === 'keyword') {
            setKeyword(value);
        } else if (name === 'status') {
            setStatus(value);
        } else if (name === 'dateFrom') {
            setDateFrom(value);
        } else if (name === 'dateTo') {
            setDateTo(value);
        }
    }

    const handleSearchClick = async () => {
        try {
            LoadOrders('', false);
        }
        catch (e) {
            console.log(e);
        }     
    };
    const handleReturnClick = (e, orderID) => {
        try {
            navigate('/creditrequest', { state: { id: orderID } });
        }
        catch (e) {
            console.log(e);
        }
    };

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % orderItems.length;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setItemOffset(newOffset);
    };

    useEffect(() => {
        setShoppingCart(GetShoppingCart());     
        document.title = 'K-Dealer - Order History';
    }, []);

    return (
        <>
            <Container className="checkout-container main-container dealer-section">

                <Row className="help-title-row checkout-title-row">
                    <Col className="help-center-title checkout-title">
                        <h1 className="heading help-heading">ORDER HISTORY</h1>
                    </Col>
                    <Col className="checkout-title-under">
                        <Row className="excel-row">
                            <Col>
                                <div className="icons-row clickable">
                                    <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />
                                    <p className="mb-0 underline">Excel Orders</p>
                                </div>
                            </Col>
                            <Col>
                                <div className="icons-row clickable">
                                    <img src="../../../Images/icon_excel.png" alt="Excel" className="excel-icon" />
                                    <p className="mb-0 underline">Excel Order Items</p>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12}>
                        <Card>
                            <Card.Body>
                                <Row>
                                    <Col sm={3}>
                                        <FloatingLabel label="Keyword" className="mb-4">
                                            <Form.Control id="keyword" type="text" placeholder="Keyword" value={keyword} className={'form-control'} onChange={handleChange} name="keyword" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Select aria-label="Status" onChange={handleChange} value={status} name="status" className="tall-select">
                                            <option value={''}>All</option>
                                            {
                                                OrderStatusList && OrderStatusList.map((item, index) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))
                                            }
                                        </Form.Select>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Date From" className="mb-4">
                                            <Form.Control id="dateFrom" type="text" placeholder="Date From" value={dateFrom} className={'form-control'} onChange={handleChange} name="dateFrom" />
                                        </FloatingLabel>
                                    </Col>
                                    <Col sm={3}>
                                        <FloatingLabel label="Date To" className="mb-4">
                                            <Form.Control id="dateTo" type="text" placeholder="Date To" value={dateTo} className={'form-control'} onChange={handleChange} name="dateTo" />
                                        </FloatingLabel>
                                    </Col>

                                    <Col sm={{ offset: 8 }} className="text-right" style={{ alignSelf: 'center' }}>
                                        <p className="clickable underline green-text" onClick={ResetSearch }>Reset Search</p>
                                    </Col>

                                    <Col className="text-center mb-3">
                                        <Button variant="secondary"  onClick={handleSearchClick}>
                                            <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                                                <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                            </svg>
                                            SEARCH
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5 mb-4">
                    <Col sm={12}>
                        <Card className="">
                            <Card.Body>
                                <Row className="table-legend text-center">
                                    <Col sm={12}>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                            <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                            <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/partially-shipped.svg" alt="" className="" /> Partially Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/shipped-active.svg" alt="" className="" /> Shipped</span>
                                            <span className="svg-holder"><img src="../../../Images/returned.svg" alt="" className="" /> Returned</span>
                                            <span className="svg-holder"><img src="../../../Images/queued.svg" alt="" className="" /> Queued</span>
                                            <span className="svg-holder"><img src="../../../Images/cancelled-inactive.svg" alt="" className="" /> Cancelled</span>
                                        </div>
                                        <div className="table-legend-section">
                                            <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        containerClassName="table-navigation"
                                        previousLinkClassName="table-nav-link"
                                        nextLinkClassName="table-nav-link"
                                    />
                                </Row>

                                <Row>
                                    <Col sm={12} className="order-table">
                                        <Table hover responsive>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>ORDER # / <br /> REF #</th>
                                                    <th>ORDER <br /> DATE</th>
                                                    <th>ORDER <br /> TYPE</th>
                                                    <th>ORDERED BY</th>
                                                    <th>SHIP <br /> METHOD</th>
                                                    <th>STATUS</th>
                                                    <th>TOTAL <br /> ITEMS</th>
                                                    <th>TOTAL</th>
                                                    <th width="10%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                
                                                {currentItems && currentItems.map((item, index) => (
                                                    <tr className="" key={item.refID}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <table className="inner-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="bold">Ord #</td>
                                                                        <td className="bold">{item.orderID}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Ref #</td>
                                                                        <td>{item.refID}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Name</td>
                                                                        <td>{item.orderName}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                        <td>{item.orderDate}</td>
                                                        <td>{item.orderType}</td>
                                                        <td>{item.orderById} <br /> {item.orderByName}</td>
                                                        <td>{item.shipMethod}</td>
                                                        <td className="table-img"> <span className="svg-holder"><img src={"../../../Images/" + item.statusImg} alt="" className="item-type-image" /></span></td>
                                                        <td>{item.totalItems}</td>
                                                        <td>{FormatCurrency(item.total)}</td>
                                                        <td className="table-row" ref={dropdownRef} style={{ position: activeRow === item.refID ? 'absolute' : 'static' }}>
                                                            <span className="underline" onClick={() =>handleDetailsModalShow(item)}>Edit</span>
                                                            <InputGroup className="">
                                                                <DropdownButton
                                                                    variant="outline-secondary"
                                                                    title=""
                                                                    id="input-group-dropdown-1"
                                                                >
                                                                    <Dropdown.Item><span className="bold">Duplicate Order</span></Dropdown.Item>
                                                                    {item.exchangable && <Dropdown.Item><span className="bold">Exchange</span></Dropdown.Item>}
                                                                    {item.returnable && <Dropdown.Item onClick={(e) => handleReturnClick(e, item.orderID)}><span className="bold">Return</span></Dropdown.Item>}
                                                                    <Dropdown.Item><span className="bold">Cancel Backorder</span></Dropdown.Item>
                                                                </DropdownButton>
                                                            </InputGroup>
                                                        </td>
                                                    </tr>
                                                ))}
                                             
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>

            <FooterDealer />

            <HistoryDetail show={showDetailsModal} handleClose={handleDetailsModalClose} order={selectedOrder} historyType={historyType} />
        </>
    );
}